// extracted by mini-css-extract-plugin
module.exports = {"rotulo":"rotulo-movimentacao_rotulo__GwY9x","compacto":"rotulo-movimentacao_compacto__23UO8"};